<div class="wrapper">
  <!-- Infinite row model does not officially support select all on infinite row models (header checkbox selection): https://www.ag-grid.com/angular-data-grid/row-models/#row-model-comparisons -->
  <ag-grid-angular
    class="ag-theme-wilson"
    wilsonSelectAllAcrossPages
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [components]="components"
    [rowMultiSelectWithClick]="true"
    [rowSelection]="'multiple'"
    [rowModelType]="'infinite'"
    [columnDefs]="columnDefs$ | async"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular>
</div>
